import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative min-h-[620px] md:min-h-[680px] w-full flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=epic%20anime%20style%20battle%20scene%20with%20a%20lone%20hero%20facing%20a%20fiery%20explosion%2C%20dark%20background%20with%20glowing%20orange%20embers%20and%20golden%20energy%20bursts%2C%20dramatic%20cinematic%20lighting%2C%20intense%20hot-blooded%20action%20manga%20illustration%2C%20high%20contrast%20red%20and%20gold%20palette%2C%20powerful%20composition&width=1600&height=900&seq=hero-fire-2026&orientation=landscape"
          alt="热血战斗爽漫英雄燃烧背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-background-50"></div>
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col items-center text-center w-full">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/60 border border-accent-500/40 px-4 py-1.5 text-xs md:text-sm text-accent-300 backdrop-blur">
            <i className="ri-flashlight-fill"></i>今日已更新 36 部爽漫
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl lg:text-7xl leading-tight text-foreground-950">
            炮渣<span className="fire-text">漫画</span>网
          </h1>
          <p className="mt-4 max-w-2xl text-base md:text-xl leading-relaxed text-foreground-200">
            无脑爽漫推荐 + 热血战斗排行，开挂主角一口气看爽。
            <br className="hidden md:block" />
            不用翻找，点开榜单直接开刷龙傲天与打脸爽文。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/recommend"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm md:text-base font-semibold text-background-50 hover:bg-primary-600 transition-colors"
            >
              <i className="ri-fire-fill text-lg"></i>马上开刷
            </Link>
            <Link
              to="/ranking"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50/60 backdrop-blur border border-foreground-300/40 px-7 py-3.5 text-sm md:text-base font-semibold text-foreground-950 hover:bg-background-50 transition-colors"
            >
              <i className="ri-medal-fill text-lg text-accent-400"></i>查看热血排行
            </Link>
          </div>

          <dl className="mt-12 grid grid-cols-3 gap-6 md:gap-12 w-full max-w-xl">
            {[
              { num: "460+", label: "收录爽漫" },
              { num: "1280w+", label: "累计推荐" },
              { num: "每天", label: "榜单热更" },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <dt className="sr-only">{s.label}</dt>
                <dd className="font-heading text-2xl md:text-4xl text-accent-400">{s.num}</dd>
                <dd className="mt-1 text-xs md:text-sm text-foreground-400">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}